import { render, staticRenderFns } from "./ApplianceCreate.vue?vue&type=template&id=a71dbb9c"
import script from "./ApplianceCreate.vue?vue&type=script&lang=js"
export * from "./ApplianceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports